import * as luxon from "luxon";
import { RepeatData } from "../../../../../dashboard_utils";
import { WithTooltip } from "../../../tooltips/with_tooltip";

export function DateTableData(props: {
	start_time_js_date: Date;
	end_time_js_date: Date;
	repeat_data?: RepeatData;
}) {
	const { start_time_js_date, end_time_js_date, repeat_data } = props;

	const start_time = luxon.DateTime.fromJSDate(start_time_js_date);
	const end_time = luxon.DateTime.fromJSDate(end_time_js_date);

	const date = start_time.toLocaleString({
		month: "short",
		day: "2-digit",
	});

	const full_date = start_time.toLocaleString({
		dateStyle: "full",
		timeStyle: "short",
	});

	const time = start_time.toLocaleString(luxon.DateTime.TIME_SIMPLE);
	const end_time_string = end_time.toLocaleString(luxon.DateTime.TIME_SIMPLE);

	let repeat_element: JSX.Element;
	let datatip_strings: string[] = [full_date];

	if (repeat_data) {
		repeat_element = <i className="fas fa-redo"></i>;
		datatip_strings.push(repeat_data.repeat_text);
	}

	const datatip = datatip_strings.join("<br />");

	const date_string = `${date} ${time} - ${end_time_string}`;

	return (
		<td className="w-full" data-tip={datatip}>
			<WithTooltip
				style="Info"
				tooltip={
					<div className="flex flex-col">
						<div>{full_date}</div>
						{repeat_data?.repeat_text && (
							<div>{repeat_data.repeat_text}</div>
						)}
					</div>
				}
			>
				<div className="flex w-full min-w-0 items-center gap-2 overflow-hidden">
					<p className="ellipsis-overflow max-w-full flex-shrink-0 overflow-hidden whitespace-nowrap">
						{date_string}
					</p>
					{repeat_element}
				</div>
			</WithTooltip>
		</td>
	);
}
